import { render, staticRenderFns } from "./EventMedia.vue?vue&type=template&id=1a09ee2a"
import script from "./EventMedia.vue?vue&type=script&lang=js"
export * from "./EventMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports